import { formatTime } from "../../utils/utils";
import { parseDate } from "../../../../../utils/dateUtils";
import styles from "./index.module.scss";

interface DateColProps {
    startDate: string;
    startTime: string;
    endTime: string;
    language: string
}

const DateCol = ({ startDate, startTime, endTime, language }: DateColProps) => {
    const parsedDate = parseDate(startDate);
    
    const formatMonthFromMoment = (momentDate: any, language: string) => {
        if (language) {
            const locale = language.toLowerCase().substring(0, 2);
            const monthName = momentDate.locale(locale).format("MMMM");
            
            if (language === "English") {
                return monthName.substring(0, 3).toUpperCase();
            } else if (language === "Hebrew") {
                return monthName.substring(0, 3);
            } else {
                return monthName;
            }
        }
        return momentDate.format("MMM").toUpperCase();
    };
    
    const formattedDates = {
        day: parsedDate.format("DD"),
        month: formatMonthFromMoment(parsedDate, language),
    };

    const formattedTime = () => {
        const startTimeFormatted = formatTime(startTime, language);
        const endTimeFormatted = formatTime(endTime, language);
        return `${startTimeFormatted}-${endTimeFormatted}`;
    }

    return (
        <div className={`${styles.date} ${language !== "English" ? styles.isNotEnglish : ""}`}>
            <div className={styles.day}>{formattedDates.day}</div>
            <div className={styles.month}>{formattedDates.month}</div>
            <div className={styles.separator}/>
            <div className={styles.time}>{formattedTime()}</div>
        </div>
    );
};

export default DateCol;